export default {
  fr: {
    Title: "Contrôle de la teneur",
    Contractual : 'Contractuel',
    Grade : 'Teneur',
    Cutoff : 'Écrêtage',
    ExtractionDate : "Date d'extraction",
    ExtractionDateShort : "Extraction",
    Shift : 'Quart',
    MuckTypeShort : 'Taille',
    BucketCount : 'Godets',
    Miner : "Opérateur",
    Actual: "Actuel",
    Total: "Total",
    Density : "Densité",
    DensityUnitMetric : "(ton/m3)",
    DensityUnitImperial : "(short ton/ft3)",
    CappingUnit: "(g/T)",
    CappingUnitImperial: "(oz/T)",
    Tonnage: "Tonnage",
    TonnageUnitMetric: "(Tonnes)",
    TonnageUnitImperial: "(Tons)",
    Volume : 'Volume',
    VolumeUnitMetric : '(m3)',
    VolumeUnitImperial : '(pi3)',
    AverageGrades : "Teneurs moyennes",
    MLViews: {
      Importation : "Vues Meliadine",
      InProgress : "Exportation des vues Meliadine en cours",
      Success : "L'exportation des vues s'est complétée avec succès",
      Failure : "L'exportation des vues a échouée",
      ConfirmImport : "Souhaitez-vous réellement déclancher l'exportation des vues Meliadine?"
    },
    Timesheet: {
      SampleStartShort : 'De',
      SampleEndShort : 'À',
      SampleCountShort : 'Quantité',
      SampleCount : "Nombre d'échantillons",
      DateSelection : 'Sélectionnez une date',
      TimesheetList : 'Feuille de temps',
      BucketCount : 'Godets',
      Tonnage : "Tonnage",
      SampleStart : 'Echantillon départ',
      SampleEnd : 'Echantillon fin',
      OverridePrefix : 'Forcer un préfix spécifique',
      SamplePrefix : "Préfixe d'échantillon",
      LocationType : 'Type de chantier',
      Destination : 'Destination',
      DestinationCannotBeSameAsLocation : "La destination ne peut pas être identique à l'emplacement.",
      BlastType : 'Type de volée',
      BlastDate : 'Date de volée',
      BlastDateShort : 'Volée',
      RoundNumber : "Numéro de volée/Block",
      RockType : 'Type de roche',
      MaterialType : 'Type de déblai',
      IsAutomation : 'Automatisé',
      Employee : 'Employé',
      TimesheetOperationType : 'Opération',
      Source : 'Source',
      TimesheetDeleted : "La feuille de temps a été correctement supprimée",
      ConfirmImport: "Souhaitez-vous réellement importer les feuilles de temps sélectionnées?",
      TooManySample: "Certaines feuilles de temps possèdent plus de 50 échantillons définis.  Souhaitez-vous tout de même importer les feuilles de temps sélectionnées?",
      ImportCompleted: "Les feuilles de temps ont été correctement importées",
      ConfirmCancelImport: "Souhaitez-vous réellement annuler l'importation de cette feuille de temps?",
      CancelImportCompleted: "L'importation de la feuilles de temps a été correctement annulée",
      ConfirmCancelImportBatch: "Souhaitez-vous réellement annuler l'importation des feuilles de temps sélectionnées?",
      CancelImportCompletedBatch: "L'importation des feuilles de temps a été correctement annulée",
      NoTimesheetSelected: "Aucune feuille de temps de sélectionnée",
      AddNew: "Nouvelle feuille de temps",
      Edit : "Édition d'une feuille de temps",
      Title: "Feuille de temps",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette feuille de temps?",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces feuilles de temps?",
      ConfirmDuplicate : "Souhaitez-vous réellement dupliquer cette feuille de temps?",
      ConfirmRestore : "Souhaitez-vous réellement restaurer cette feuille de temps?",
      RestoreCompleted : "La feuille de temps a été correctement restaurée",
      AddNewLocation: "Créer une location",
      SampleRanges : "Échantillons",
      Step1 : "Général",
      Importation: {
        ResultTitle: "Résultats de l'importation"
      },
      ShowDeleted : 'Afficher les feuilles de temps supprimées',
      Versions: "Versions",
      VersionEventType : {
        '0' : "Créé",
        '1' : "Modifiée",
        '2' : "Supprimée",
        '3' : "Restaurée",
        '4' : "Approuvée"
      },
      VersionProperties: {
        BlastDate: 'Date de volée'
      },
      VersionList: "Liste des versions",
      VersionChanged: "Modifications apportées",
      VersionComment: "Commentaire",
      VersionOldValue: "Ancienne valeur",
      VersionNewValue: "Nouvelle valeur",
      VersionUpdateComplete: "La version de cette feuille de temps a été correctement mise à jour",
      Comments: "Commentaires",
      OperationComments: "Commentaires Operations",
      UserComments: "Commentaires utilisateur",
      OverrideDensity: "Surpasser",
      Density: "Densité",
      LocationForecastDensity: "Densité chantier",
      ModificationDate: "Date de modification",
      ApprovalDate: "Date d'approbation",
      EquipmentRequired: "Équipement requis",
      EquipmentRequiredMessage: "Vous devez sélectionner un équipement avant d'entrer un tonnage"
    },
    Forecast: {
      Name: "Prévision",
      Title: "Prévisions",
      AddNew: "Nouvelle prévision",
      Edit : "Édition d'une prévision",
      ForecastList : 'Prévisions',
      ForecastDeleted :  "La prévision a été correctement supprimée",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette prévision?",
      ConfirmDuplicate : "Souhaitez-vous réellement dupliquer cette prévision?",
      CancelApprobation : "Retirer approbation",
      ConfirmCancelApprobation : "Souhaitez-vous réellement désapprouver cette prévision?",
      ConfirmCancelBatchApprobation : "Souhaitez-vous réellement désapprouver ces prévisions?",
      Tonnage : "Tonnage",
      Statistics : "Statistiques",
      NoForecastSelected : "Aucune prévision de sélectionnée",
      ApprobationCompleted : "Les prévisions sélectionnées ont été correctement approuvées",
      CancellationCompleted: "Les prévisions sélectionnées ont été correctement désapprouvées",
      ConfirmApprobation : "Souhaitez-vous réellement approuver ces prévisions?",
      CopyNextMonth : "Transposer",
      ConfirmCopyNextMonth :  "Souhaitez-vous réellement copier ces prévisions au mois prochain?",
      CopyNextMonthCompleted : "Les prévisions sélectionnées ont été correctement copié au mois prochain",
      ConfirmDeleteMultiple : "Souhaitez-vous réellement supprimer ces prévisions?",
      Step1 : "Général",
      Step2 : "Éléments",
      UploadFile : "Téléverser le fichier de prévision",
      UploadInvalidFileError : "Fichier de téléversement invalide",
      UploadSuccess : "Le fichier de prévision a été correctement importé",
      UploadFails : "Erreur d'importation",
      UploadFailText : "Le fichier de téléchargement a une structure non pris en charge. Veuillez télécharger le dernier modèle disponible et réessayer",
      TemplateFile : "Obtenir le modèle de d'importation de prévisions",
      SelectMonth : "Sélectionner le mois",
      MonthlyTab: "Mensuel",
      AnnualTab: "MRMR annuel",
      Annual: {
        Title: "Prévisions MRMR annuelles",
        SelectYear: "Sélectionner l'année",
        Year: "Année",
        AddNew: "Nouvelle prévision annuelle",
        Edit: "Édition d'une prévision annuelle",
        Quantity: "Quantité",
        Unit: "Unité",
        Grade: "Teneur",
        Category: "Catégorie",
        ImportedQuantity: "Quantité importée",
        Upload: "Téléverser le classeur MRMR",
        UploadFile: "Téléverser les prévisions annuelles de {year}",
        UploadHint: "Classeur Excel (.xlsx) bâti sur la feuille TemplateImport : Location, Tonnage, Density, AU (g), AG (g), CU (kg), ZN (kg), PB (kg), CAT, ProductionType. Le fichier est importé en entier ou refusé.",
        UploadInvalidFileError: "Seuls les classeurs Excel (.xlsx) sont acceptés",
        UploadRefused: "Le fichier a été refusé, rien n'a été importé",
        UploadSuccess: "{forecasts} prévision(s) annuelle(s) importée(s) pour {year}, {locations} location(s) créée(s)",
        ApprovedBy: "Approuvée par",
        ApprobationDate: "Date d'approbation",
        NoForecastSelected: "Aucune prévision annuelle de sélectionnée",
        ConfirmApprobation: "Souhaitez-vous réellement approuver les prévisions annuelles sélectionnées?",
        ApprobationCompleted: "Les prévisions annuelles sélectionnées ont été correctement approuvées",
        ConfirmCancelApprobation: "Souhaitez-vous réellement désapprouver cette prévision annuelle?",
        ConfirmCancelBatchApprobation: "Souhaitez-vous réellement désapprouver les prévisions annuelles sélectionnées?",
        CancellationCompleted: "Les prévisions annuelles sélectionnées ont été correctement désapprouvées",
        Transpose: "Transposer",
        ConfirmTranspose: "Souhaitez-vous réellement copier les prévisions annuelles sélectionnées vers {year}?",
        TransposeCompleted: "Les prévisions annuelles sélectionnées ont été correctement copiées vers {year}",
        ConfirmDelete: "Souhaitez-vous réellement supprimer cette prévision annuelle?",
        ConfirmDeleteMultiple: "Souhaitez-vous réellement supprimer les prévisions annuelles sélectionnées?",
        ForecastDeleted: "Les prévisions annuelles sélectionnées ont été correctement supprimées",
        Step1: "Général",
        Step2: "Éléments"
      }
    },
    ProductionSummary: {
      Title: "Sommaire de production",
      LongTitle: "Sommaire de production par emplacement",
      GradePerPeriod : "Évolution de la teneur et du tonnage",
      GoldProduction : "Au Onces",
      Sample: "Échantillons",
      ReceivedSamples: "Reçus",
      TotalSamples: "Total"
    },
    MonthlySummary: {
      Title: "Suivi mensuel",
      ForecastTonnage : "Tonnage prévu",
      ActualTonnage : "Tonnage effectué",
      LocationFollowup: "Suivi de location",
      GradeDistribution: "Distribution des teneurs"
    },
    Posting: {
      Title: "Fermeture du mois",
      LocationList : "Liste des locations comptabilisées",
      ConfirmPost: "Souhaitez-vous réellement comptabiliser les locations sélectionnées?",
      PostCompleted: "Les locations ont été correctement comptabilisées",
      NoForecastSelected: "Aucune location de sélectionnée",
      ConfirmText: "Veuillez confirmer la comptabilisation",
      ConfirmCancelPosting: "Souhaitez-vous réellement annuler la comptabilisation de cette location?",
      CancelPostingCompleted: "La comptabilisation de la location a été correctement annulée",
      NoPostedLocationSelected: "Aucune location comptabilisés de sélectionné",
      ConfirmCancelPostingBatch: "Souhaitez-vous réellement annuler la comptabilisation des location sélectionnées?",
      CancelPostingCompletedBatch: "La comptabilisation des location a été correctement annulée"
    },
    Muck: {
      MuckDeleted : "L'extraction a été correctement supprimée",
      MuckList : "Liste des extractions",
      HaulingList : "Liste des halages",
      AddNew : "Nouvelle extraction",
      Edit : "Édition d'une extraction",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cette extraction?",
      ApprovedBy: "Approuvé par",
      ApprovalDateTime: "Date de l'approbation",
      ReceivedSampleRate: "Taux d'échantillon reçu"
    },
    Sample: {
      Title: 'Échantillon',
      SampleMeasures : 'Liste des mesures',
      LIMSTitle: "Importation des résultats d'échantillons",
      ReceivedDate: 'Date de réception',
      CertifiedDate : 'Date de certification',
      Received : 'Réception',
      Certified : 'Certification',
      Code: "Code",
      IncludedSamples : 'Échantillons inclus',
      ExcludedSamples : 'Échantillons exclus',
      IncludedLocationSampleResults : "Résultats approuvés inclus",
      ExcludedLocationSampleResults : "Résultats approuvés exclus",
      IncludedSampleMeasure : "Mesures d'échantillon incluses",
      ExcludedSampleMeasure : "Mesures d'échantillon excluses",
      AutoExcludedSampleMeasure : "Mesures d'échantillon automatiquement excluses",
      SampleDeleted : "L'échantillon sélectionné a été correctement supprimé",
      SampleList : "Liste d'échantillons",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cet échantillon?",
      ConfirmExclusion : "Souhaitez-vous réellement exclure cet échantillon?",
      SampleExcluded :  "L'échantillon sélectionné a été correctement exclu",
      ConfirmInclusion : "Souhaitez-vous réellement inclure cet échantillon?",
      SampleGoldGrade : "Teneur en Or des échantillons",
      SampleReceivedRate : "Reçu (%)",
      SampleReceivedAuRate : "Reçu Au(%)",
      SampleReceivedBaseRate : "Reçu Base(%)",
      SampleNumber : "Code",
      Certificate : "Certificat",
      MonthlyStats : 'Statistique mensuelle',
      NoSampleSelected : "Aucun échantillon de sélectionné",
      ConfirmSingleImport: "Souhaitez-vous réellement importer l'échantillon?",
      ConfirmCancelImport: "Souhaitez-vous réellement annuler l'importation de cet échantillon?",
      ConfirmImport: "Souhaitez-vous réellement importer les échantillons sélectionnés?",
      ImportCompleted: "Les échantillons ont été correctement importés",
      ConfirmCancelImportBatch: "Souhaitez-vous réellement annuler l'importation des échantillons sélectionnés?",
      CancelImportCompletedBatch: "L'importation des échantillons a été correctement annulé",
      CancelImportCompleted : "L'importation de l'échantillon a été correctement annulé",
      QCType : "Type de CQ",
      OnlyWarnings : "Uniquement les décisions à prendre",
      ImportedNoExclusion : 'Importés sans exclusion',
      ImportedWithExclusion : 'Importés avec exclusions',
      Orphan : 'Orphelins',
      NotImported : 'Non importés',
      OnlyNonApprouved : 'Afficher tous les échantillons non importés',
      Importation: {
        ResultTitle: "Résultats d'importation"
      }
    },
    Location: {
      Title : 'Emplacement',
      Name : 'Emplacement',
      AddNew : "Nouvel emplacement",
      Edit : "Édition d'un emplacement",
      Code : "Code",
      Type : 'Type de production',
      IsActive: "Actif",
      OnlyActive: "Actifs seul.",
      AlternateCodes : "Codes alternatifs (séparés par un point-virgule)",
      AlternateCodesShort: "Codes alternatifs",
      GoldGradeStatistics : "Statistiques de la teneur en Or",
      ConfirmDelete : "Souhaitez-vous réellement supprimer l'emplacement {code}?",
      LocationDeleted: "L'emplacement a été correctement supprimé",
      Capping : "Écretage"
    },
    Employee: {
      Title : 'Employées',
      AddNew: "Nouvel employé",
      Edit : "Édition d'un employé",
      Name: "Employee",
      Code: "Numéro d'employé",
      FirstName : "Prénom",
      LastName : "Nom",
      IsActive: "Actif",
      ConfirmDelete :  "Souhaitez-vous réellement supprimer l'employé {code}?",
      EmployeeDeleted: "L'employé sélectionné a été correctement supprimé"
    },
    MuckType: {
      ModelName : 'Type de muck',
      Title : 'Types de muck',
      Name : 'Nom',
      Code : 'Code',
      Factor : 'Facteur',
      Comments : 'Commentaires',
      AddNew : "Nouveau type de muck",
      Edit : "Édition d'un type de muck",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce type de muck {code}?",
      LocationDeleted: "Le type de muck a été correctement supprimé"
    },
    MaterialSubType: {
      ModelName : 'Sous-type de déblai',
      Title : 'Sous-types de déblai',
      Name : 'Nom',
      Code : 'Code',
      IsActive: "Actif",
      OnlyActive: "Actifs seul.",
      AddNew : "Nouveau sous-type de déblai",
      Edit : "Édition d'un sous-type de déblai",
      ConfirmDelete : "Souhaitez-vous réellement supprimer ce sous-type de déblai {code}?",
      LocationDeleted: "Le sous-type de déblai a été correctement supprimé"
    },
    Equipment: {
      Title : 'Équipements',
      Name : 'Équipement',
      Code : 'Code',
      Company: 'Compagnie',
      Type: 'Type',
      AddNew : "Nouvel équipement",
      Edit : "Édition d'un équipement",
      Description : 'Description',
      Volume : 'Volume',
      IsActive: "Actif",
      OnlyActive: "Actifs seul.",
      ConfirmDelete : "Souhaitez-vous réellement supprimer cet équipment {code}?",
      EquipmentDeleted: "L'équipment a été correctement supprimé"
    },
    EquipmentType: {
      '0': 'Chargeuse navette',
      '1': 'Camion'
    },
    Reports: {
      Title: "Rapports",
      Dashboard : "Tableau de bord",
      Timesheet : "Feuille de temps",
      Stockpile : "Suivi des haldes",
      Muck : "Extractions",
      Annual : "Annuel",
      Monthly : "Mensuels",
      Periodic : "Périodiques",
      DailyMonitoring : "Suivi Quotidien",
      LocationSummary : "Sommaire par Location",
      ProductionSummary : "Tableau de Progression",
      PostingSummary : "Sommaire Comptabilisé",
      Summary : "Sommaire Global de Production",
      SummaryOtherMaterial : "Sommaire Global de Production (Autres types de déblai)",
      SummaryLive : "Sommaire Global de production (temps réel)",
      Forecast : "Prévisions",
      SampleStats : "Statistiques d'échantillons",
      LabStats : "Statistiques de laboratoire",
      SampleAnomalies : "Anomalies d'échantillonage",
      SampleSummary : "Détail d'un échantillon",
      SampleTracking : "Recherche d'échantillon",
      DailyLocationStats : "Moyenne havage par chantier journalier",
      LocationSummaryStats : "Sommaire Havage Teneur",
      Goldex : "Rapports Goldex",
      Odyssey : "Rapports Odyssey",
      Detour : "Rapports Detour",
      DeswikExport : "Export Deswik"
    },
    Admin: {
      Title : "Admin"
    },
    TimesheetOperationType:{
      '0': 'Déblaiement',
      '1': 'Remanutention',
      '2': 'Halage'
    },
    Destinations: {
      Title: "Destinations"
    },
    Destination: {
      AddNew: "Ajouter",
      Edit: "Modifier",
      Name: "Nom",
      Type: "Type",
      ConfirmDelete: "Voulez-vous vraiment supprimer la destination?",
      DestinationDeleted: "La destination a été supprimée."
    },
    BlastType: {
      '0': "Round",
      '1': "Slash",
      '2': "Bench",
      '3': "Backslash round"
    },
    DestinationType: {
      '1': "Baie Remuck",
      '2': "Ore Pass",
      '3': "Camion",
      '4': "Stock Pile"
    },
    RemuckForecast: {
      Title: "Densité de remanutention mensuelle",
      Edit: "Modifier la densité de remanutention mensuelle",
      Density : "Densité"
    },
    TimesheetsSummary: {
      Title: "Total approuvé",
      Total: "Total"
    },
    NSRForecast: {
      Title: "NSR",
      Save: "Sauvegarder les prévisions NSR",
      Reserve: "$ Réserve",
      ThreeMonths: "$ 3 mois",
      Annual: "Annuel",
      Monthly: "Mensuel",
      Au: "$ Au",
      Ag: "$ Ag",
      Cu: "$ Cu",
      Zn: "$ Zn",
      Pb: "$ Pb",
      NSRReserve: "NSR Rés.",
      NSR3Months: "NSR 3 mois",
      LockedBy: "Verrouillé par {user} le {date} à {time}",
      MetalPrice: "Prix des métaux",
      RecoveryPercentage: "% de récupération",
      CurrencyRate: "Taux de change",
      RefineryCostPerTon: "Coût de raffinage par tonne",
      CuAuId: "Cu + Au",
      ZnId: "Zn",
      ZnBelowThreshold: "Si Zn < {threshold}%",
      ZnAboveThreshold: "Si Zn >= {threshold}%",
      ZnGrade: "Concentration Zn",
      NSRDisabled: "Le module de gestion des NSR est désactivé dans votre organisation."
    },
    NSRForecastType: {
      '0': "Réserve",
      '1': "3 mois"
    }
  }
}
